import React, { useRef } from 'react';
import { Card, IconButton } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import StTextField from '../misc/textField';
import StButton from "../misc/button";
import { withFirebase } from '../Firebase'
import { Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as ROUTES from '../../constants/routes'

const NewSoundtrailScreen = (props) => (
    <NewSoundtrailScreenWithFirebase {...props} />
)

const makeCode = () => {
    var result = '';
    var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < 4; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
 

const NewSoundtrailScreenBase = props => {

    const [name, setName] = React.useState("")
    const [stxUrl, setStxUrl] = React.useState("")
    const [redirect, doRedirect] = React.useState(false)
    const [posting, setPosting] = React.useState(false)
    const [postingReason, setPostingReason] = React.useState("")
    const [file, setFile] = React.useState({ isInvalid: true, name: "Upload Thumbnail" })

    const handleCreate = async () => {
        setPosting(true)
        const { firebase } = props;

        const userData = await firebase.getUserData()
        const data = userData.data();

        setPostingReason("Generating code...");

        let code = makeCode();
        for (let i = 0; i <= 3; i++) {
            
            // making sure the codes aren't vulgar
            // add more as you think of them
            // TODO: make separate function for this
            if (code === "fuck" || 
                code === "cunt" || 
                code === "dick" || 
                code.includes("ass") ||
                code.includes("poo")) {
                code = makeCode();
                i--;
                continue;
            }

            if (await firebase.checkSoundtrailCode(code)) break;
            else if (i >= 3) {
                code += makeCode()[0];
                i = 1;
            }
            code = makeCode();
        }

        setPostingReason("Uploading thumbnail...");

        if (!file.isInvalid) {
            await firebase.setThumbnail(file.name, file);
        }

        if (file.name === "Upload Thumbnail") {
            file.name = "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQfUQknW-WBP_Xmqiy_SLy5tSP4nPfFKgD50g&usqp=CAU";
        }

        setPostingReason("Creating soundtrail...");

        firebase.createSoundtrail(
            name,
            "",
            data.name,
            data.stxUrl + stxUrl,
            file.name,
            data.uuid,
            code
        ).then(() => { props.onClose() || doRedirect(true); window.location.reload(); })
    }

    const changeName = (newName) => {
        if (stxUrl === name.replace(/ /g, "_") + ".stx" || stxUrl === "") {
            setStxUrl(newName.replace(/ /g, "_") + ".stx")
        }
        setName(newName)
    }

    const fileInputRef = useRef(null);

    const handleBtnClick = () => {
        fileInputRef.current.click();
    }

    const handleFileNameChange = () => {
        setFile(fileInputRef.current.files[0])
    }

    if (redirect) {
        return <Redirect to={ROUTES.HOME} />;
    }

    if (posting) {
        return (
            <div className="App">
                <Card style={{ height: "550px", width: "400px", position: "relative" }}>
                    <CircularProgress style={{ marginTop: "150px" }} />
                    <br />
                    <p style={{color:"#888888"}}>{postingReason}</p>
                </Card>
            </div>
        )
    }

    const isInvalid =
        name === '' ||
        stxUrl === '';
    return (
        <div className="App">
            <Card style={{ height: "400px", width: "400px", position: "relative" }}>
                <IconButton style={{ left: "-170px" }} onClick={() => { props.onClose() || doRedirect(true) }} ><ArrowBackIcon /></IconButton>
                <div>
                    <h1 style={{ marginTop: "-10px" }}>Create Soundtrail</h1>
                    <br />
                </div>
                <StTextField id="name" label="Soundtrail Name" onChange={changeName} />
                <br />
                <br />
                <br />
                <StTextField id="stxUrl" label="STX File Name" value={stxUrl} onChange={setStxUrl} />
                <br />
                <br />
                <br />
                <StButton style={{ margin: "5px" }} onClick={handleBtnClick} text={file.name} />
                <StButton style={{ margin: "5px" }} onClick={handleCreate} text={"Create"} isDisabled={isInvalid} />
                <input onChange={handleFileNameChange} ref={fileInputRef} type="file" style={{ visibility: "hidden" }} />
            </Card>
        </div>
    );
}

const NewSoundtrailScreenWithFirebase = withFirebase(NewSoundtrailScreenBase);

export default NewSoundtrailScreen